import { addBusinessDays, format } from 'date-fns';

export const CALLBACK_TIMES = [
  {
    title: 'Morning (09:00 - 12:00)',
    value: 9,
  },
  {
    title: 'Early afternoon (12:00 - 15:00)',
    value: 12,
  },
  {
    title: 'Last afternoon (15:00 - 19:00)',
    value: 15,
  },
];

const today = new Date();
today.setHours(0, 0, 0, 0);

export const CALLBACK_DATES = Array.from({ length: 6 }, (_, index) => {
  const newDay = addBusinessDays(today, index);
  return {
    title:
      (index === 0 ? 'Today - ' : '') + format(newDay, 'iiii (yyyy-MM-dd)'),
    value: newDay.toISOString(),
  };
});
